<div class="px-4 py-6 max-w-3xl mx-auto">
    <!-- record title name  -->
    <!-- and description -->
    <div class="bg-blue-50 border border-blue-200 rounded-2xl p-4 mb-6">
        <div class="flex items-center justify-between">
            <div class="flex-1">
                <p class="text-sm font-medium text-blue-900">記録タイトル: 活動記録</p>
                <div class="flex items-center gap-3 mt-1">
                    <p class="text-xs text-blue-700">{{
                        (allDirtyForms && allDirtyForms!.length > 0) ? allDirtyForms!.length + '名分の記録を作成中':
                        '各お子様をタップして記録を入力'
                        }}</p>
                    <span class="text-xs bg-green-600 text-white px-2 py-0.5 rounded-full"
                        *ngIf="submittedForm.length > 0">{{ submittedForm.length + '件保存済み'}}</span>
                </div>
            </div>
        </div>
    </div>
    <!-- search -->
    <div class="mb-4">
        <div class="relative"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide lucide-search absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400">
                <circle cx="11" cy="11" r="8"></circle>
                <path d="m21 21-4.3-4.3"></path>
            </svg>
            <input type="text" placeholder="お子様を検索" [(ngModel)]="searchClassStr"
                class="w-full pl-10 pr-10 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
                value="">
        </div>
    </div>
    <!-- list -->
    <div class="space-y-3 flex flex-col w-full gap-3">
        <!-- class list -->
        <ng-container *ngFor="let classForm of displayClasses">
            <app-class [classForm]="$any(classForm)"></app-class>
        </ng-container>

    </div>
    <div class="mt-6 sticky bottom-0 z-10">
        <button (click)="onSubmit()"
            [ngClass]="['w-full rounded-xl py-4 font-medium transition-colors shadow-lg', (dirtyForms.length > 0 ? 'bg-blue-600 text-white hover:bg-blue-700' : 'bg-gray-300 text-gray-500 cursor-not-allowed')]">{{
            dirtyForms.length > 0 ? '未保存の'+ dirtyForms.length +'件をまとめて保存' : '記録を入力してください'
            }}
        </button>
    </div>
</div>